<template>
  <div id="myCarousel" class="carousel slide wp_ProductSliderSingle">
    <!-- main slider carousel items -->
    <div class="carousel-inner">
      <div class="active item carousel-item prdt-carousel-item"
           v-if="product.product_details &&
                     product.product_details.images &&
                     product.product_details.images[0]"
           :data-slide-number="(imageSelected < 0?
                     imageSelected+=1:
                     (imageSelected > product.product_details.images.length-1?
                     imageSelected-=1:
                     imageSelected))"
      >
        <!--<wish-list-->
        <!--v-if="(product.vendor_product_inventories &&-->
        <!--product.vendor_product_inventories[selectedVendorIndex])"-->
        <!--:product="product"-->
        <!--&gt;-->
        <!--</wish-list>-->
        <out-of-stock v-if="outOfStock">
        </out-of-stock>
        <vue-zoom :img="product.product_details.images[imageSelected]"
                  :id="product.product_details.images[imageSelected]"
                  :width="100"
                  :magnify="20"
                  class="img-fluid"
                  v-if="showZoom"
                  >
        </vue-zoom>
        <div class="zoomedimgwrapper">

        </div>
        <!--<img :src=product.product_details.images[imageSelected]-->
        <!--class="img-fluid"-->
        <!--:id="'product-details-img-1'+product.product_id"-->
        <!--&gt;-->
      </div>
    </div>
    <!-- main slider carousel nav controls -->
    <ul class="carousel-indicators list-inline"
        v-if="product.product_details &&
                  product.product_details.images &&
                  product.product_details.images[0]"
    >
      <a class="carousel-control left pt-3"
         href="#myCarousel"
         data-slide="prev"
         @click.prevent="imageSelected -= 1"
         id="mycarousel-prev"
									data-test="imageLightBoxDetailsSectionLink1"
      >
        <i class="fa fa-chevron-left" data-test="imageLightBoxDetailsSectionfaIcon1"
											id="imageLightBoxDetailsSectionfaIcon1"></i>
      </a>
      <li
        :class="(imageSelected === key)?
                  'list-inline-item active':
                  'list-inline-item'"
        v-for="(image, key) in product.product_details.images"
        :key="key"
      >
        <a id="carousel-selector-0" class="selected"
           :data-slide-to="key"
           @click.prevent="imageSelected = key"
           data-target="#myCarousel"
											:data-test="'imageLightBoxDetailsSectionLink2'+key"
        >
          <img :src="image" class="img-fluid"
               :id="'product-details-img-7'+product.product_id"
															:data-test="'imageLightBoxDetailsSectionImg'+key"
          >
        </a>
      </li>
      <a class="carousel-control right pt-3"
         href="#myCarousel"
         data-slide="next"
         @click.prevent="imageSelected += 1"
         id="mycarousel-next"
									data-test="imageLightBoxDetailsSectionLink3"
      >
        <i class="fa fa-chevron-right" data-test="imageLightBoxDetailsSectionfaIcon2"
											id="imageLightBoxDetailsSectionfaIcon2"></i>
      </a>
    </ul>
  </div>

</template>

<script>
import OutOfStock from '@/components/widgets/outofstock/OutOfStock'
import VueZoom from 'vue-zoom'

export default {
	name: 'image-detail-section',
	data () {
		return {
			imageSelected: 0,
			selectedVendorIndex: 0,
			showZoom: true
		}
	},
	components: {
		OutOfStock,
		VueZoom
	},
	watch: {
		$route () {
			this.imageSelected = 0
			this.showZoom = false
			setTimeout(() => {
				this.showZoom = true
			}, 50)
		},
		imageSelected () {
			const data3 = document.getElementsByClassName('zoomImg')
			if (data3 && data3.length > 0) {
				data3[0].remove()
			}
		}
	},
	props: {
		product: {},
		outOfStock: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped>

</style>
